'use strict';

angular.module('licensure.services')
    .factory('XSLTStylesheets', ['$http', '$q', function ($http, $q) {
        return {
            get: function () {
                var d = $q.defer();

                $http
                    .get(apiLocation + '/api/XSLTStylesheets', {
                        params: {
                        
                        }
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                        // handle error
                    });

                return d.promise;
            },

            getStylesheetContent: function (args) {
                var d = $q.defer();

                $http
                    .get(apiLocation + '/api/XSLTStylesheets/GetStylesheetContent', {
                        params: args
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                        // handle error
                    });

                return d.promise;
            }
        }
    }])
;